module.exports = "/packs/templates.membership_reminder-8e3ddd5f.html";